import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { type StyleSheet } from '@blaze-shared/theming-domain';

@Component({
  selector: 'blaze-style-sheet-role-icon',
  imports: [MatIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './style-sheet-role-icon.component.html',
  styleUrls: ['./style-sheet-role-icon.component.scss'],
})
export class StyleSheetRoleIconComponent {
  @Input() styleSheet: StyleSheet;
  @Input() showNoIconPlaceholder = true;
}
